<template>
  <div class="dynamic-page-wrapper">
    <h1 class="page-header">
      {{ pageTitle }}
    </h1>
    <div class="page-dynamic-content flex-col">
      <PageSection v-for="(section, index) in sections" :key="`${index}-section`" :section="section" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { QueryTypes } from '~/server/utils/contentstack';
import { contentstackRequest } from '~/util/contentstack/api';
import { metaGen } from '~/util/metadata';
import { getFirstIndex } from '~/util/arrays';
import { useRootStore } from '~/store';

const { locale } = useI18n();
const rootStore = useRootStore();
const event = useRequestEvent();

const { data: asyncData, error: asyncError } = await useAsyncData(async () => {
  const contentStackData = await contentstackRequest(QueryTypes.page, '/shipping-returns', {
    event,
    query: {
      locale: locale?.value,
    },
  });
  // console.log('cts data', contentStackData)
  if (!contentStackData) throw createError({ statusCode: 404, message: 'Page not found' });

  const page = getFirstIndex(contentStackData?.data?.all_page?.items);
  if (!page) throw createError({ statusCode: 404, message: 'Page not found' });
  return {
    contentStackData,
    page,
    locale: locale?.value,
  };
});

useAsyncErrorHandling({
  error: asyncError.value,
});

useHead({
  ...(metaGen(rootStore?.brandSettings, {
    ...(asyncData.value?.page?.seo || {}),
  }) as any),
});

const sections = computed<{ [index: string]: any }[]>(() => {
  const sectionToDisplay = 'default messaging';
  const dataSections: any[] = [];
  (asyncData.value?.page?.sections || []).forEach((section: any) => {
    if (section?.section_name?.toLowerCase() === sectionToDisplay) {
      dataSections.push(section);
    }
  });
  return dataSections;
});
const pageTitle = computed<string>(() => {
  return asyncData.value?.page?.display_title || '';
});
</script>
